module.exports = __webpack_public_path__ + "img/product_104.1f04ffd.svg";